export default "__VITE_ASSET__BZB7pEYL__"